export const ACCOUNTS_PAGE = 'ACCOUNTS_PAGE'
export const DASHBOARD_PAGE = 'DASHBOARD_PAGE'
export const PRODUCT_PAGE = 'PRODUCT_PAGE'
export const DELETE_PRODUCT = 'DELETE_PRODUCT'
export const DELETE_CATEGORY = 'DELETE_CATEGORY'
export const ADD_PRODUCT = 'ADD_PRODUCT'
export const ADD_CATEGORY = 'ADD_CATEGORY'
export const UPDATE_CALL_API = 'UPDATE_CALL_API'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const IS_LOGGED_IN = 'IS_LOGGED_IN'
export const IS_LOGGED_OUT = 'IS_LOGGED_OUT'
export const DELETE_USER = 'DELETE_USER'
